"use client";
import {
  useGroupLabel
} from "../__chunks/YUOJWFSO.js";
import "../__chunks/7HVFURXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest
} from "../__chunks/3YLGPPWQ.js";

// src/form/form-group-label.tsx
var TagName = "div";
var useFormGroupLabel = createHook(
  function useFormGroupLabel2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroupLabel(props);
    return props;
  }
);
var FormGroupLabel = forwardRef(function FormGroupLabel2(props) {
  const htmlProps = useFormGroupLabel(props);
  return createElement(TagName, htmlProps);
});
export {
  FormGroupLabel,
  useFormGroupLabel
};
